const SUPPORT_HOST = 'soporte.goldloterias.com';
const SUPPORT_PATH = '/app';

/**
 * Builds FreeScout support portal URL (mirrors mobile SupportTicketLauncher).
 * Auth is optional: pass email / userId when the user is logged in.
 */
export function buildSupportTicketUrl({ email, userId } = {}) {
  const params = new URLSearchParams({
    app_version: 'web',
    build_number: process.env.REACT_APP_VERSION || '0.1.0',
    os: 'Web',
    device: 'Browser',
  });

  if (email && String(email).trim()) {
    params.set('email', String(email).trim());
  }

  if (userId != null && userId !== '') {
    params.set('user_id', String(userId));
  }

  return `https://${SUPPORT_HOST}${SUPPORT_PATH}?${params.toString()}`;
}

export function isAllowedSupportHost(host) {
  const normalized = String(host || '').toLowerCase();
  return (
    normalized === SUPPORT_HOST || normalized.endsWith(`.${SUPPORT_HOST}`)
  );
}

export const SUPPORT_CONTACTS = {
  phoneDisplay: '313 8572510',
  phoneTel: 'tel:+573138572510',
  premiosEmail: 'premios@goldloterias.com',
  soporteEmail: 'soporte@goldloterias.com',
  address: 'Diagonal 75 B # 8-40, Oficina 221 (Medellín, Antioquia)',
  mapsUrl:
    'https://www.google.com/maps/search/?api=1&query=6.2163,-75.5975',
};
